import React from 'react'

import SingleSupplierView from 'src/modules/buyer/modules/suppliers/components/SingleSupplierView'

const PublicSingleSupplierView = props => {
  return (
    <SingleSupplierView
      {...props}
      canLeaveReview={false}
      canMessage={false}
      canStar={false}
      canRequestAgreement={false}
      linkPrefix="/public"
      showPrices={false}
    />
  )
}

export default PublicSingleSupplierView
